<template>
  <section class="mb-6">
    <nav class="columns">
      <div class="column is-4">
        <nav class="level pb-0">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.meeting_employee') }}
              </p>
              <p class="title is-size-5">
                {{
                  `(${this.meeting.employee_code}) ${this.meeting.employee_name}`
                }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.meeting_tel') }}
              </p>
              <p class="title is-size-5">
                {{ this.meeting.tel || '&nbsp;' }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.lecturer') }}
              </p>
              <p class="title is-size-5">
                {{ this.meeting.lecturer || '&nbsp;' }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.assistant') }}
              </p>
              <p class="title is-size-5">
                {{ this.meeting.assistant || '&nbsp;' }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('attributes.meal_provided') }}
              </p>
              <p class="title is-size-5">
                {{ whetherStatus(this.meeting.meal_provided) }}
              </p>
            </div>
          </div>
        </nav>
      </div>
      <div class="column is-5">
        <nav class="level pb-0">
          <div class="level-left">
            <div class="level-item">
              <div>
                <p class="heading">
                  {{ $t('attributes.meeting_desc') }}
                </p>
                <p class="title is-size-5">
                  {{ this.meeting.description || '&nbsp;' }}
                </p>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="column is-3">
        <div class="buttons is-right">
          <b-button
            v-if="canModify()"
            type="is-primary"
            style="width: 80px;"
            @click.prevent.stop="onApplyAdd"
            :disabled="isExpired()"
          >
            <span class="icon">
              <i class="mdi mdi-plus" />
            </span>
            {{ $t('attributes.add') }}
          </b-button>
          <b-button
            v-if="canModify()"
            :loading="sending"
            class="is-warning"
            @click="onSend"
            :disabled="isExpired()"
          >
            {{ $t('attributes.update') }}
          </b-button>
          <b-button
            v-if="canModify()"
            :loading="sending"
            class="is-success"
            @click="onExport"
          >
            {{ $t('message.export') }}
          </b-button>
        </div>
      </div>
    </nav>

    <section class="mt-4">
      <form-wrapper :validator="$v.form">
        <b-table
          :data="applies"
          :loading="loadingApplicants"
          hoverable
          narrowed
          scrollable
        >
          <b-table-column
            field="id"
            :visible="false"
            :label="$t('attributes.id')"
            width="400"
            v-slot="props"
          >
            {{ props.row.id }}
          </b-table-column>
          <b-table-column label="順位" width="80" centered v-slot="props">
            <b-tag
              :type="
                props.row.index > meeting.capacity ? 'is-warning' : 'is-primary'
              "
              size="is-medium"
            >
              {{ props.row.index.toString().padStart(3, '0') }}
            </b-tag>
          </b-table-column>
          <b-table-column
            field="employee_code"
            :label="$t('attributes.employee_code')"
            width="100"
            v-slot="props"
          >
            <p class="nowrap">
              {{ props.row.employee_code }}
            </p>
          </b-table-column>
          <b-table-column
            field="employee_name"
            :label="$t('attributes.employee_name')"
            width="160"
            v-slot="props"
          >
            <p class="nowrap">
              {{ props.row.employee_name }}
            </p>
          </b-table-column>
          <b-table-column
            field="tel"
            :label="$t('attributes.meeting_tel')"
            width="160"
            v-slot="props"
          >
            <b-input
              v-if="canModify() & !isExpired()"
              v-model="props.row.tel"
              name="tel"
              maxlength="20"
              :has-counter="false"
              :placeholder="
                $t('message.please_input_', [$t('attributes.meeting_tel')]) +
                  $t('message.word_limit', [20])
              "
            ></b-input>
            <p v-else>
              {{ props.row.tel }}
            </p>
          </b-table-column>
          <b-table-column
            field="remark"
            :label="$t('attributes.remark')"
            v-slot="props"
          >
            <b-input
              v-if="canModify() & !isExpired()"
              v-model="props.row.remark"
              name="remark"
              maxlength="500"
              :has-counter="false"
              :placeholder="
                $t('message.please_input_', [$t('attributes.remark')])
              "
            ></b-input>
            <p v-else>
              {{ props.row.remark }}
            </p>
          </b-table-column>
          <b-table-column
            field="created_at"
            :label="$t('attributes.meeting_apply_at')"
            width="180"
            v-slot="props"
          >
            {{ formatDateTime(props.row.created_at) }}
          </b-table-column>

          <b-table-column
            v-if="canModify()"
            :label="$t('attributes.function')"
            width="60"
            centered
            v-slot="props"
          >
            <div class="buttons is-centered">
              <b-button
                type="is-danger"
                size="is-small"
                @click="onDeleteApply(props.row)"
                :disabled="isExpired()"
              >
                <span class="icon">
                  <i class="mdi mdi-delete" />
                </span>
              </b-button>
            </div>
          </b-table-column>

          <template #empty>
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
              </div>
            </section>
          </template>
        </b-table>
      </form-wrapper>

      <div v-if="canModify()" class="mt-2 buttons is-right">
        <b-button
          v-if="canModify()"
          type="is-primary"
          style="width: 80px;"
          @click.prevent.stop="onApplyAdd"
          :disabled="isExpired()"
        >
          <span class="icon">
            <i class="mdi mdi-plus" />
          </span>
          {{ $t('attributes.add') }}
        </b-button>
        <b-button
          v-if="canModify()"
          :loading="sending"
          class="is-warning"
          @click="onSend"
          :disabled="isExpired()"
        >
          {{ $t('attributes.update') }}
        </b-button>
        <b-button
          v-if="canModify()"
          :loading="sending"
          class="is-success"
          @click="onExport"
        >
          {{ $t('message.export') }}
        </b-button>
      </div>
    </section>

    <b-modal
      :active.sync="isApplyFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <meeting-lesson-apply-form
        :isOwner="true"
        :meeting="meeting"
        :meeting-apply="selectedApply"
        :sending="sending"
        @onCreate="onCreateApplies"
      />
    </b-modal>

    <b-loading
      :active="loadingApplicants"
      :is-full-page="true"
      :can-cancel="false"
    />
  </section>
</template>

<script>
import Vue from 'vue'
import { MEETING_API } from '@/utils/apis'
import MeetingLessonApplyForm from './MeetingLessonApplyForm'
import notifyService from '@/services/notifyService'
import { MEETING_TYPE } from '@/utils/constants'
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'MeetingLesson',
  components: { MeetingLessonApplyForm },

  props: {
    meeting: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadingApplicants: false,

      originApplicants: [],
      applicants: [],

      selectedApply: null,
      isApplyFormModalActive: false,

      form: {
        applicants: []
      },

      sending: false
    }
  },
  computed: {
    applies() {
      return this.applicants.filter(a => a.status !== 'delete')
    }
  },
  watch: {
    meeting(item) {
      this.loadApplicants(item)
    }
  },
  validations() {
    return {
      form: {
        applicants: {
          required,
          $each: {
            name: {
              requiredIf: requiredIf(function(model) {
                return model.status !== 'delete'
              }),
              maxLength: maxLength(20)
            },
            tel: { maxLength: maxLength(20) },
            remark: { maxLength: maxLength(200) }
          }
        }
      }
    }
  },
  mounted() {
    this.loadApplicants(this.meeting)
  },
  methods: {
    async loadApplicants(meeting) {
      try {
        const api = `${MEETING_API}/${meeting.id}/applicants`
        this.loadingApplicants = true
        const res = await this.axios.get(api)
        this.originApplicants = res.data.data
        this.applicants = res.data.data.map((apply, index) => ({
          id: apply.id,
          index: index + 1,
          status: 'update',
          employee: `(${apply.employee_code}) ${apply.employee_name}`,
          employee_code: apply.employee_code,
          employee_name: apply.employee_name,
          name: apply.name,
          tel: apply.tel,
          remark: apply.remark,
          created_at: apply.created_at
        }))
      } catch (e) {
        this.originApplicants = []
        this.applicants = []

        notifyService.fetch_error('meeting_applicants', e)
      } finally {
        this.loadingApplicants = false
      }
    },
    isExpired() {
      return this.meeting.is_expired
    },
    canModify() {
      const user = Vue.$auth.user()

      if (user.is_admin) {
        return true
      }

      if (this.meeting.employee_code === user.emp_code) {
        return true
      }

      return false
    },

    onApplyAdd() {
      const last =
        this.applicants.length > 0
          ? this.applicants[this.applicants.length - 1].index + 1
          : 1

      this.selectedApply = {
        id: null,
        index: last,
        status: 'create',
        employee_code: null,
        employee_name: null,
        name: null,
        tel: null,
        remark: null,
        created_at: null
      }
      this.isApplyFormModalActive = true
    },
    onCreateApplies(applies) {
      this.isApplyFormModalActive = false
      this.applicants.push(applies[0])
    },
    onDeleteApply(apply) {
      if (apply.status === 'create' && !apply.name) {
        this.applicants = this.applicants
          .filter(a => a.index !== apply.index)
          .map(a => ({
            ...a,
            index: a.index > apply.index ? a.index - 1 : a.index
          }))
      } else {
        this.$buefy.dialog.confirm({
          message: this.$t('message.confirm_cancel_meeting'),
          onConfirm: () => {
            this.deleteApply(apply)
          }
        })
      }
    },
    deleteApply(apply) {
      if (apply.status === 'create') {
        this.applicants = this.applicants
          .filter(a => a.index !== apply.index)
          .map(a => ({
            ...a,
            index: a.index > apply.index ? a.index - 1 : a.index
          }))
      } else {
        apply.status = 'delete'
      }
    },
    async onSend() {
      this.form.applicants = [...this.applicants]

      this.$v.$touch()
      if (this.$v.$invalid) {
        notifyService.error('請確實選擇每位員工')
        return
      }

      this.$emit('onSend', this.meeting, this.form.applicants)
    },

    async onExport() {
      const api = `${MEETING_API}/${this.meeting.id}/export`

      const config = {
        headers: { Accept: 'application/vnd.ms-excel' },
        responseType: 'blob'
      }

      try {
        this.sending = true
        const response = await this.axios.post(api, {}, config)

        const type =
          this.meeting.type === MEETING_TYPE.BRIEFING ? '說明會' : '上順教室'
        const date = this.$dayjs().format('YYYYMMDDHHmmss')
        const fileName = `${this.meeting.title}_${type}_${date}`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        notifyService.error('下載失敗', e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
